export default __webpack_public_path__ + "static/media/_ghiacco_secco_3mm.de351c81.png";